export default "__VITE_ASSET__DaunxGpl__";